module.exports = __webpack_public_path__ + "static/media/tommy-logo.40b6bf61.mp4";